import React from 'react';
import { DialogContent, DialogTitle, Divider, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ContactFormValues, ContactType } from '../../types';
import { MainInformationForm } from './FormLayout/MainInformationForm';
import { AdditionalInformationForm } from './FormLayout/AdditionalInformationForm';

interface Props {
  contactFormValues: ContactFormValues;
  contactType: ContactType;
  setContactFormValues: any;
  setContactType: any;
  isLoading: boolean;
}

export const AddNewContactLayout = ({
  contactFormValues,
  contactType,
  setContactFormValues,
  setContactType,
  isLoading,
}: Props) => {
  const classes = useStyles();

  return (
    <>
      <DialogTitle>
        Add New Contact
        <Divider style={{ marginTop: 10 }} />
      </DialogTitle>
      {!isLoading && (
        <DialogContent>
          <Grid container spacing={2} className={classes.mainInformationContainer}>
            <MainInformationForm
              contactFormValues={contactFormValues}
              contactType={contactType}
              setContactFormValues={setContactFormValues}
              setContactType={setContactType}
            />

            {contactType === 'signor-and-guarantor' && (
              <AdditionalInformationForm
                contactFormValues={contactFormValues}
                setContactFormValues={setContactFormValues}
              />
            )}
          </Grid>
        </DialogContent>
      )}
    </>
  );
};

const useStyles = makeStyles({
  mainInformationContainer: {
    backgroundColor: '#f5f5f5',
    padding: 15,
    borderRadius: 6,
  },
});
